import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { ErrorBoundary } from "./components/shared/ErrorBoundary";
import "./styles/globals.css";
import "./features/onboarding/onboarding.css";
import "./components/ui/ui-extras.css";
import "./app/layout/app-shell.css";
import "./features/search/search.css";
import "./features/duas/duas.css";
import "./features/dashboard/dashboard.css";
import "./features/inbox/inbox-focus.css";
import "./features/collections/organize.css";
import "./features/library/library.css";
import "./features/sessions/sessions.css";
import "./features/journey/journey.css";
import "./features/settings/settings.css";
import "./features/settings/storage-privacy.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root was not found");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
